import React, { useCallback, useRef } from "react";

import Button from "@mui/material/Button";
import VideoOffIcon from "../../../../icons/VideoOffIcon";
import VideoOnIcon from "../../../../icons/VideoOnIcon";

import useDevices from "../../../../hooks/useDevices/useDevices";
import useLocalVideoToggle from "../../../../hooks/useLocalVideoToggle/useLocalVideoToggle";
import { typography } from "../../../../utils/typography";
import { semanticColors } from "../../../../utils/colors";
import { useTranslation } from "react-i18next";

export default function ToggleVideoButton(props: {
  disabled?: boolean;
  className?: string;
  labelStyle?: string;
  iconStyleCamOn?: string;
  iconStyleCamOff?: string;
}) {
  const { t } = useTranslation();
  const [isVideoEnabled, toggleVideoEnabled] = useLocalVideoToggle();
  const lastClickTimeRef = useRef(0);
  const { hasVideoInputDevices } = useDevices();

  const toggleVideo = useCallback(() => {
    if (Date.now() - lastClickTimeRef.current > 500) {
      lastClickTimeRef.current = Date.now();
      toggleVideoEnabled();
    }
  }, [toggleVideoEnabled]);

  return (
    <Button
      className={props.className}
      onClick={toggleVideo}
      disabled={!hasVideoInputDevices || props.disabled}
      startIcon={
        isVideoEnabled ? (
          <VideoOnIcon iconStyleCamOn={props.iconStyleCamOn} />
        ) : (
          <VideoOffIcon iconStyleCamOff={props.iconStyleCamOff} />
        )
      }
      sx={{
        ...typography.body.l,
        color: semanticColors.text.primary,
        textTransform: "none"
      }}
    >
      <span className={props.labelStyle}>
        {!hasVideoInputDevices
          ? t("videoButtons.noCamera")
          : isVideoEnabled
          ? t("videoButtons.disableCamera")
          : t("videoButtons.enableCamera")}
      </span>
    </Button>
  );
}
